import React from 'react';

const Dropdown = ({ id, label, small, options }) => {
    const outer = React.useRef(null);
    const [show, setShow] = React.useState(false);

    const handleClick = e => {
        if (outer.current && !outer.current.contains(e.target)) {
            setShow(false);
        }
    };

    React.useEffect(() => {
        document.addEventListener('click', handleClick, false);

        return () => document.removeEventListener('click', handleClick, false);
    }, []);

    return (
        <div ref={outer} id={id} className={show ? 'btn-group open' : 'btn-group'}>
            <button
                id={`${id}-btn`}
                className={`btn btn-primary dropdown-toggle ${small ? 'btn-xs' : ''}`}
                onClick={() => setShow(!show)}
            >
                {label || 'Open'}
                <i className="fa fa-caret-down ml5" />
            </button>
            <ul className="dropdown-menu general">
                {options.map((o, i) => {
                    return (
                        <li className="pointer" key={`option-${i}`}>
                            <button
                                className={`btn-link ${small ? 'btn-xs' : ''}`}
                                onClick={() => {
                                    o.onClick && o.onClick();
                                    setShow(false);
                                }}
                            >
                                <span>{o.name}</span>
                            </button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default Dropdown;
